<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="'Share Checklist'"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (!loaded && errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (!loaded) {
      <tidy-card>
        <tidy-row class="extra-bottom-padding vertical-align-center">
          <ion-skeleton-text animated style="width: 24px; height: 24px; border-radius: 4px; margin-right: 8px;" />
          <ion-skeleton-text animated style="width: 200px; height: 20px;" />
        </tidy-row>
        @for (i of [1,2,3]; track i) {
          <tidy-row class="extra-bottom-padding">
            <ion-skeleton-text animated style="width: 150px; height: 16px;" />
          </tidy-row>
        }
        <tidy-row class="extra-bottom-padding extra-top-padding">
          <tidy-divider />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <ion-skeleton-text animated style="width: 100%; height: 50px; border-radius: 6px;" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <ion-skeleton-text animated style="width: 80%; height: 16px;" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <ion-skeleton-text animated style="width: 100%; height: 16px;" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <ion-skeleton-text animated style="width: 100%; height: 44px; border-radius: 6px;" />
        </tidy-row>
        <tidy-row class="extra-top-padding" [align]="'center'">
          <ion-skeleton-text animated style="width: 80px; height: 16px;" />
          <ion-skeleton-text animated style="width: 120px; height: 16px; margin-left: 4px;" />
        </tidy-row>
      </tidy-card>
    }

    @if (loaded) {
      <tidy-card>
        <tidy-row class="extra-bottom-padding vertical-align-center">
          <tidy-image
            [src]="'assets/svg/list-circle.svg'"
            class="header-size" />
          <tidy-text
            [header]="selectedListName"
            [translate]="false" />
        </tidy-row>
        @for (room of rooms; track room) {
          <tidy-row>
            <tidy-text
              [body]="room?.name"
              [translate]="false" />
          </tidy-row>
        }
        <tidy-row class="extra-bottom-padding extra-top-padding">
          <tidy-divider />
        </tidy-row>
        <tidy-row>
          <form [formGroup]="form">
            <tidy-select
              [icon]="'assets/svg/home-outline.svg'"
              [label]="'Property'"
              [form]="form.controls.address"
              formControlName="address"
              [items]="addressItems"
              (optionChange)="getListLink($event)" />
            </form>
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'Share your checklist with anyone and they can mark what was done:'" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="listLink" />
          @if (copied) {
            <tidy-text
              style="margin-left:5px"
              [helper]="'Copied'" />
          }
        </tidy-row>
        <tidy-button
          [action]="boundCopyLink"
          [text]="'Copy Checklist Link'"
          class="primary" />
        <tidy-row class="extra-top-padding" [align]="'center'">
          <tidy-text
            class="link"
            [actionBody]="'Learn More'"
            (action)="learnMore()" /><span>&nbsp;</span>
            <tidy-text
              [body]="'about checklist links'" />
          </tidy-row>
        </tidy-card>
        @if (errorMessage) {
          <tidy-error-message
            [text]="errorMessage" />
        }
      }
    </tidy-wrapper>
  </ng-template>

  @if (!isRightSideContent) {
    <app-scroll-wrapper [templateContent]="content" />
  }

  @if (isRightSideContent) {
    <ion-content class="ion-content-right-column">
      <ng-container *ngTemplateOutlet="content" />
    </ion-content>
  }
